import * as model from './';

export interface SalesMetricJSON {
  salePrice: number;
  salePriceFormatted: string;
  pricePerUnit: number;
  pricePerUnitFormatted: string;
  salesDate: string;
  salesYear: string;
  capRate: number;
  capRateFormatted: string;
}

export interface SaleInformationJSON extends SalesMetricJSON {
  buildingCount: number;
  acres: number;
  acresFormatted: string;

  buyer: BuyerJSON;
  seller: SellerJSON;
  lender: LenderJSON;
  broker: BrokerJSON;
}

export interface BuyerJSON {
  name: string;
  group: string;
  type: string;
  country: string;
  objective: string;
}

export interface SellerJSON {
  name: string;
  group: string;
  type: string;
  country: string;
}

export interface LenderJSON {
  name: string;
  loanAmount: string;
}

export interface BrokerJSON {
  buyer: string;
  seller: string;
}

export class Lender extends model.EntityBase implements LenderJSON {
  name: string;
  loanAmount: string;

  constructor(lenderJson: BuyerJSON) {
    super(lenderJson);
  }
}

export class Broker extends model.EntityBase implements BrokerJSON {
  buyer: string;
  seller: string;

  constructor(brokerJson: BuyerJSON) {
    super(brokerJson);
  }
}

export class SaleEntity extends model.EntityBase implements BuyerJSON {
  name: string;
  group: string;
  type: string;
  country: string;
  objective: string;

  constructor(saleEntityJson: BuyerJSON) {
    super(saleEntityJson);
  }
}

export class SaleInfo extends model.EntityBase implements SaleInformationJSON {
  salePrice: number;
  salePriceFormatted: string;
  pricePerUnit: number;
  pricePerUnitFormatted: string;
  salesDate: string;
  salesYear: string;
  capRate: number;
  capRateFormatted: string;

  buildingCount: number;
  acres: number;
  acresFormatted: string;

  buyer: SaleEntity;
  seller: SaleEntity;
  lender: Lender;
  broker: Broker;

  constructor(json: any) {
    super(json);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/model/SaleInformation.ts